// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://otyynwsyjyfwhthfwwvm.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im90eXlud3N5anlmd2h0aGZ3d3ZtIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDM0NTAwNTQsImV4cCI6MjA1OTAyNjA1NH0.DfiJmsH8swrgK5Pp9VTIJPAzlEiH-SfsM2Rc73yXo9g";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);